import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-olx',
  templateUrl: './olx.component.html',
  styleUrls: ['./olx.component.scss']
})
export class OlxComponent {
  menuOpen = false;

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }


  /** Smooth scroll to a section by its ID */
  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  /** Handle clicking on internal navigation links */
  onNavClick(event: Event, id: string): void {
    event.preventDefault();
    this.scrollTo(id);
    if (this.menuOpen) {
      this.toggleMenu();
    }
  }

  protected readonly environment = environment;
}
